// extracted by mini-css-extract-plugin
export var bigTitle = "iconModule-module--bigTitle--qmfwu";
export var decoration = "iconModule-module--decoration--7YoxS";
export var description = "iconModule-module--description--D1CMi";
export var gradient = "iconModule-module--gradient--5petP";
export var iconElement = "iconModule-module--iconElement--guBNW";
export var icons = "iconModule-module--icons--xso3E";
export var pureImage = "iconModule-module--pureImage--dyqms";
export var rightSide = "iconModule-module--rightSide--9aPIa";
export var sbShowMain = "iconModule-module--sb-show-main--+nXYz";
export var subtitle = "iconModule-module--subtitle--HTbYy";
export var title = "iconModule-module--title--pRokw";
export var totaraBackground = "iconModule-module--totaraBackground--AqZjK";
export var twoRows = "iconModule-module--twoRows--MAo3d";
export var wrapper = "iconModule-module--wrapper--JvdTq";